<template>
	<li :class="`coupon_card_container ${isExpired ? 'coupon_expired' : ''}`">
		<div class="coupon_card_header">
			<p class="heading_6 f_secondary_3">{{ setTitle() }}</p>
			<CouponLabel :text="'오프라인 쿠폰'" />
			<CouponLabel v-if="isImminentExpired && !isExpired" :text="'만료임박'" :color="'syetemred'" />
		</div>
		<div class="coupon_card_content">
			<p class="heading_7">{{ title }}</p>
			<p class="body_9 f_gray_4" style="whiteSpace: pre-line">{{ memo }}</p>
			<div>
				<p class="body_9 f_gray_4">
					사용가능:
					<b class="heading_10 f_gray_4">전국 Speedmate 오프라인 매장</b>
				</p>
				<p class="body_9 f_gray_4">
					사용기한:
					<b :class="`heading_10 ${isExpired || isImminentExpired ? 'f_red_3' : 'f_gray_4'
						}`
						">{{ period }}</b>
				</p>
			</div>
		</div>
		<Button :label="isExpired ? '사용기간 만료' : '쿠폰보기'" :disabled="isExpired" :size="44" :color="'gray'"
			:onClick="handleToastOpen" />
		<Toast :isVisible="isOpenToast" :title="title" :onClose="handleToastClose">
			<div class="barcode_container">
				<svg :id="`barcode_${couponNum}`" />
				<div class="barcode_character">
					<span class="body_10" v-for="(v, i) in couponNum" :key="i">
						{{ v }}
					</span>
				</div>
			</div>
		</Toast>
	</li>
</template>

<script>
import moment from 'moment'
import CouponLabel from '../label/CouponLabel.vue'
import Button from '../AiButton.vue'
import Toast from '../AiToast.vue'
import JsBarcode from 'jsbarcode'

export default {
	data() {
		return {
			isImminentExpired: false,
			isExpired: false,
			period: '',
			isOpenToast: false
		}
	},
	props: {
		couponMethod: {
			type : Number,
			default : 10
		},
		couponSeq: {
			type: Number,
			required: true
		},
		couponDiscount: {
			type: Number,
			defalut: 0
		},
		title: {
			type: String
		},
		memo: {
			type: String
		},
		paymentDate: {
			type: String
		},
		expiryDate: {
			type: String
		},
		couponNum: {
			type: String
		}
	},
	methods: {
		setExpired() {
			const diffAt = moment.duration(
				moment(this.expiryDate).diff(undefined, 'second'),
				'second'
			)
			const diffDays = diffAt.asDays()
			const diffHours = diffAt.hours()
			const diffMinutes = diffAt.minutes()

			if (diffDays > 0) {
				if (diffDays <= 3) {
					this.isImminentExpired = true
					if (diffDays > 1) {
						this.period = `${diffAt.days()}일 후 만료`
					} else {
						this.period =
							diffHours > 0
								? `${diffHours}시간 ${diffMinutes}분 남음`
								: `${diffMinutes}분 남음`
					}
				} else {
					this.period = `${this.paymentDate} ~ ${this.expiryDate}`
				}
			} else {
				this.isExpired = true
				this.period = '만료'
			}
		},
		setTitle() {
			switch (this.couponMethod) {
				case 10:
					return `${this.couponDiscount}% 할인`
				case 20:
					return `${this.couponDiscount.toLocaleString()}원 할인`
				case 30:
					return `혜택가 ${this.couponDiscount.toLocaleString()}원`
			}
		},
		handleToastOpen() {
			const svg = document.getElementById(`barcode_${this.couponNum}`)
			JsBarcode(svg, this.couponNum, {
				margin: 0,
				width: 2.5,
				height: 60,
				displayValue: false
			})

			this.isOpenToast = true
		},
		handleToastClose() {
			this.isOpenToast = false
		}
	},
	components: {
		CouponLabel,
		Button,
		Toast
	},
	mounted: function () {
		this.setExpired()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/ai/card/CouponCard.vue